import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Field } from 'react-final-form';
import PropTypes from 'prop-types';
import Form from '@piconetworks/pkg-form';

var _excluded = ["fieldContainerProps", "description", "required", "contrastColor", "themeColor"];
var Dropdown = function Dropdown(_ref) {
  if (_ref === void 0) {
    _ref = {};
  }
  var _ref2 = _ref,
    fieldContainerProps = _ref2.fieldContainerProps,
    _ref2$description = _ref2.description,
    description = _ref2$description === void 0 ? null : _ref2$description,
    required = _ref2.required,
    contrastColor = _ref2.contrastColor,
    themeColor = _ref2.themeColor,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(Form.Field, fieldContainerProps, /*#__PURE__*/React.createElement("p", null, description), /*#__PURE__*/React.createElement(Field, _extends({
    component: Form.Dropdown,
    contrastColor: contrastColor,
    themeColor: themeColor,
    type: "text"
  }, required && {
    validate: function validate(value) {
      return value ? undefined : 'Required';
    }
  }, rest)));
};
Dropdown.propTypes = {
  fieldContainerProps: PropTypes.shape({
    label: PropTypes.string,
    required: PropTypes.boolean
  }),
  description: PropTypes.string,
  required: PropTypes.oneOfType([PropTypes.func, PropTypes.boolean]),
  contrastColor: PropTypes.string,
  themeColor: PropTypes.string
};

export { Dropdown as default };
//# sourceMappingURL=index.js.map
